<template>
    <div class="qrcode">
        <div class="nameSpan">
            <span>请将此二维码对准自助服务终端二维码扫码器进行扫描</span>
        </div>
        <div id="qrcode" ref="qrcode" class="code"></div>
        <div class="button">
            <van-button block type="info" @click="goInput">
            重新填写
            </van-button>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
    name: 'qrCode',
    data() {
        return {

        }
    },
    mounted() {
        
    },
    methods: {
        // 初始化页面
        init(form) {
            this.clear()
            // 拼接填写二维码
            let qrcodeText = form.partyName + "@" + form.partyIdcard + "@" + form.partyMobile + "@" + form.acceptCourt + "@" + form.acceptCourtName + "@" + 
                            form.serviceAreaCode + "@" + form.serviceAreaCodeValue + "@" + form.serviceAddress + "@" + form.caseCategory + "@" + form.caseType 
                            + "@" + form.caseCategoryName + "@" + form.caseTypeName
            //生成二维码
            let qrcode = new QRCode('qrcode', {
                width: 200,
                height: 200, // 高度
                text: qrcodeText // 二维码内容
            })
        },

        // 重新填写
        goInput(){
            this.$parent.goInput()
        },

        // 清空二维码
        clear() {
            let doc = document.getElementById("qrcode")
            doc.innerHTML = ""
        }
    },
}
</script>

<style scoped>
.qrcode{
    display:flex;
    flex-direction:column;
    justify-content: center;
    text-align: center;
    align-items: center;
    margin: 30px;
}

.nameSpan {
    font-size: 18px;
    color: rgb(245, 165, 1);
    justify-content: center;
    text-align: center;
}

.code{
    margin-top: 20%;
    margin-bottom: 20%;
}

.button{
    width: 80%;
}

</style>





// WEBPACK FOOTER //
// src/view/mobile/input-qrCode.vue